import React from "react";

const NewTabLink = (props) => {
  if (!props.href) {
    return <>{props.children}</>;
  }

  return (
    <a
      href={props.href}
      className={props.className}
      target="_blank"
      rel="noopener noreferrer"
    >
      {props.children}
    </a>
  );
};

export default NewTabLink;
